module.exports = __webpack_public_path__ + "img/lg_ring_r_c_1_0@2x.da5c4073.png";